import checkAuthenticated from '@/router/middlewares/checkAuthenticated';
import checkLinkedEmployee from "@/router/middlewares/checkLinkedEmployee";
import beforeEnterCheck from "@/router/middlewares/beforeEnterCheck";
import DECORATION_TYPES from '@/router/enums/DECORATION_TYPES';

export default [
  {
    path: '/inquiries',
    name: 'InquiriesView',
    component: () =>
      import(
        /* webpackChunkName: "inquiries-view" */ '../modules/inquiries/components/InquiriesView'
      ),
    meta: {
      moduleId: 'projectInquiries',
      decorations: [DECORATION_TYPES.GENERATE_TABLE_CACHE_ID]
    },
    beforeEnter: checkAuthenticated
  },
  {
    path: '/inquiries/:id',
    name: 'InquiryForm',
    component: () =>
      import(
        /* webpackChunkName: "inquiries-form" */ '../modules/inquiries/components/InquiryForm'
      ),
    meta: { 
      moduleId: 'projectInquiries',
      preloads: ['system/countries/default']
    },
    props: true,
    beforeEnter: beforeEnterCheck,
  },
  {
    path: '/projects',
    name: 'ProjectsView',
    component: () =>
      import(
        /* webpackChunkName: "projects-view" */ '../modules/projects/components/ProjectsView'
      ),
    meta: {
      moduleId: 'projectsOverview',
      decorations: [DECORATION_TYPES.GENERATE_TABLE_CACHE_ID],
    },
    beforeEnter: checkAuthenticated
  },
  {
    path: '/projects/:id',
    name: 'ProjectForm',
    component: () =>
      import(
        /* webpackChunkName: "projects-form" */ '../modules/projects/components/form/ProjectForm'
      ),
    meta: {
      moduleId: 'projectsOverview',
      registries: ['configurations/projects', 'configurations/deviations'],
      preloads: ['system/countries/default'],
    },
    props: true,
    beforeEnter(to, from, next) {
      beforeEnterCheck(to, from, next);
      to.params['showMessageButton'] = false;
    }
  },
  {
    path: '/extern/projects/:token',
    name: 'ProjectExternForm',
    component: () =>
      import(
        /* webpackChunkName: "projectExternForm" */ '../../src/modules/project/components/ProjectExternForm'
      ),
    props: true,
    beforeEnter(to, from, next) {
      if (from.path === '/extern/login') 
        to.params['showProcessDeviationDialog'] = true;
      else
        to.params['showProcessDeviationDialog'] = false;
      next();
    }
  },
  {
    path: '/extern/login',
    name: 'LoginExtern',
    component: () =>
      import(
        /* webpackChunkName: "loginExtern" */ '../../src/modules/login/LoginExtern'
    ),
    props: true
  },
  {
    path: '/initial-assessment-project-assignments',
    name: 'InitialAssessmentProjectAssignmentsView',
    component: () =>
      import(
        /* webpackChunkName: "initial-assessment-project-assignments-view" */ '../modules/projects/components/InitialAssessmentProjectAssignmentsView'
      ),
    meta: {
      moduleId: 'initialAssessmentProjectAssignments',
      decorations: [DECORATION_TYPES.GENERATE_TABLE_CACHE_ID],
    },
    beforeEnter: checkAuthenticated
  },
  {
    path: '/repair-project-assignments',
    name: 'RepairProjectAssignmentsView',
    component: () =>
      import(
        /* webpackChunkName: "repair-project-assignments-view" */ '../modules/projects/components/RepairProjectAssignmentsView'
      ),
    meta: {
      moduleId: 'repairProjectAssignments',
      decorations: [DECORATION_TYPES.GENERATE_TABLE_CACHE_ID],
    },
    beforeEnter: checkAuthenticated
  },
  {
    path: '/qs-project-assignments',
    name: 'QSProjectAssignmentsView',
    component: () =>
      import(
        /* webpackChunkName: "qs-project-assignments-view" */ '../modules/projects/components/QSProjectAssignmentsView'
      ),
    meta: {
      moduleId: 'qsProjectAssignments',
      decorations: [DECORATION_TYPES.GENERATE_TABLE_CACHE_ID],
    },
    beforeEnter: checkAuthenticated
  },
  {
    path: '/projects/:id/workflow-action/:actionId',
    name: 'ProjectWorkflow',
    component: () =>
      import(
        /* webpackChunkName: "project-workflow" */ '../modules/projects/workflow-sub-module/ProjectWorkflow'
      ),
    meta: {
      moduleId: 'projectsOverview',
      registries: ['configurations/deviations'],
    },
    props: true,
    beforeEnter: beforeEnterCheck,
  },
  {
    path: '/deviations',
    name: 'ProcessDeviationsView',
    component: () =>
      import(
        /* webpackChunkName: "process-deviations-view" */ '../modules/process_deviations/ProcessDeviationsView'
      ),
    meta: {
      moduleId: 'deviations',
      decorations: [DECORATION_TYPES.GENERATE_TABLE_CACHE_ID],
    }
  },
  {
    path: '/deviations/:id',
    name: 'ProcessDeviationForm',
    component: () =>
      import(
        /* webpackChunkName: "process-deviations-form" */ '../modules/process_deviations/ProcessDeviationsForm'
      ),
    meta: {
      moduleId: 'deviations',
    },
    props: true,
    beforeEnter: beforeEnterCheck,
  },
  {
    path: '/projects-external-repair',
    name: 'ExternalRepairProjectsView',
    component: () =>
      import(
        /* webpackChunkName: "projects-external-repair-view" */ '../modules/projects/components/ExternalRepairProjectsView'
      ),
    meta: {
      moduleId: 'externalRepairProjectsOverview',
      decorations: [DECORATION_TYPES.GENERATE_TABLE_CACHE_ID],
    },
    beforeEnter: checkAuthenticated
  },
  {
    path: '/projects-vos',
    name: 'VOSProjectsView',
    component: () =>
      import(
        /* webpackChunkName: "projects-vos-view" */ '../modules/projects/components/VOSProjectsView'
      ),
    meta: {
      moduleId: 'VOSProjectsOverview',
      decorations: [DECORATION_TYPES.GENERATE_TABLE_CACHE_ID],
    },
    beforeEnter: checkAuthenticated
  },
  {
    path: '/projects-rental',
    name: 'RentalProjectsView',
    component: () =>
      import(
        /* webpackChunkName: "projects-rental-view" */ '../modules/projects/components/RentalProjectsView'
      ),
    meta: {
      moduleId: 'rentalProjectsOverview',
      decorations: [DECORATION_TYPES.GENERATE_TABLE_CACHE_ID],
    },
    beforeEnter: checkAuthenticated
  },
  {
    path: '/projects-warranty',
    name: 'WarrantyProjectsView',
    component: () =>
      import(
        /* webpackChunkName: "projects-warranty-view" */ '../modules/projects/components/WarrantyProjectsView'
      ),
    meta: {
      moduleId: 'warrantyProjectsOverview',
      decorations: [DECORATION_TYPES.GENERATE_TABLE_CACHE_ID],
    },
    beforeEnter: checkAuthenticated
  },
  {
    path: '/projects-goodwill',
    name: 'GoodwillProjectsView',
    component: () =>
      import(
        /* webpackChunkName: "projects-goodwill-view" */ '../modules/projects/components/GoodwillProjectsView'
      ),
    meta: {
      moduleId: 'goodwillProjectsOverview',
      decorations: [DECORATION_TYPES.GENERATE_TABLE_CACHE_ID],
    },
    beforeEnter: checkAuthenticated
  },
  {
    path: '/projects-disposal',
    name: 'DisposalProjectsView',
    component: () =>
      import(
        /* webpackChunkName: "projects-disposal-view" */ '../modules/projects/components/DisposalProjectsView'
      ),
    meta: {
      moduleId: 'disposalProjectsOverview',
      decorations: [DECORATION_TYPES.GENERATE_TABLE_CACHE_ID],
    },
    beforeEnter: checkAuthenticated
  },
  {
    path: '/preview',
    name: 'ProjectTemplateView',
    component: () =>
      import(
        /* webpackChunkName: "project-template-view" */ '@/modules/projects/components/templates/ProjectTemplateView'
      ),
    meta: {
      moduleId: 'projectsPreview',
      decorations: [DECORATION_TYPES.GENERATE_TABLE_CACHE_ID],
    },
    beforeEnter: checkAuthenticated
  },
  {
    path: '/preview/:id',
    name: 'ProjectTemplateForm',
    component: () =>
      import(
        /* webpackChunkName: "project-template-form" */ '@/modules/projects/components/templates/ProjectTemplateForm'
      ),
    meta: {
      moduleId: 'projectsPreview',
    },
    props: true,
    beforeEnter: beforeEnterCheck,
  }
];
